import { render, staticRenderFns } from "./FormSectionModal.vue?vue&type=template&id=bb3bc13e"
import script from "./FormSectionModal.vue?vue&type=script&lang=js"
export * from "./FormSectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports